import { createContext } from '@lit/context';
export const pristineFieldContext = createContext('pristine-field');
export const fieldValueContext = createContext('field-value');
//# sourceMappingURL=password-checklist-item-context.js.map